/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Message from '../Common/Message/Message';
import './Unsubscribe.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Unsubscribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: {
                title: '',
                content: '',
                type: ''
            },
            token: '',
            hasUnsubscribed: false,
        };
    }

    componentDidMount = () => {
        if(this.props.routeProps.location.search){
            const urlParams = new URLSearchParams(window.location.search);
            this.setState({ 
                token: urlParams.get('token'),
            });
        } else {
            this.setMessage(window.general_strings.msg.oops, 'Your token is invalid.', 'error');
        }
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }


    submit = async () => {
        this.setMessage('', '', 'loading');
        let token = this.state.token;

        const unsubscribeResponse = await unsubscribe(token);
        console.log('unsubscribeResponse:', unsubscribeResponse);
        if (!unsubscribeResponse.data.error) {
            this.setMessage('You have been unsubscribed.', strings.contentSuccess, 'success');
            this.setState({
                hasUnsubscribed: true,
            });
            setTimeout(() => {
                this.setMessage('', '', '');
                this.setState({
                    hasUnsubscribed: false,
                });
            }, 7000);
        } else {
            this.setMessage(window.general_strings.msg.oops, unsubscribeResponse.data.error.code, 'error');
        }

        async function unsubscribe(token) {
            return await ApiRequest(`/unsubscribe/email`, {
                method: 'POST',
                data: {
                    token,
                },
            });
        }
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.title}</h1>
                            <p>{strings.content}</p>
                        </div> 
                    </div>
                    <Message
                        message={this.state.message}
                    />
                    {!this.state.hasUnsubscribed && (
                        <div className="row">
                            <div className="col-12">
                                <button
                                    className={`showtix-button showtix-background__primary-1`}
                                    onClick={() => this.submit()}
                                    disabled={this.state.message.type === 'loading'}
                                >
                                    <span>{strings.unsubscribe}</span>
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

Unsubscribe.propTypes = {
    
}

export default Unsubscribe;



// WEBPACK FOOTER //
// ./src/components/Unsubscribe/Unsubscribe.js